(($) => {
  $(document).ready(() => {
    const menu = $('#nav .menu-menu-1-container')
    const openButton = $('#open-menu')
    const closeButton = $('#close-menu')

    openButton.click(() => {
      menu.addClass('open')
    })

    closeButton.click(() => {
      menu.removeClass('open')
    })
  })
})(jQuery)
